import { EUserType } from "./userInfo.model";

export class User {
    accountType: EUserType;
    firstName: string;
    lastName: string;
    gender: EGender;
    company: string;
    remark: string;
    street: string;
    zip: string;
    city: string;
    country: string;
    phone: number;
    mobile: number;
    email: string;
    password: string;
    userId: string;
    isMailValidated: boolean;
    receivedInvitationMail: boolean;
    receivedDismissalMail: boolean;
    receivedNewRoundMail: boolean;
    invitationMailScheduled: boolean;
}

export enum EGender {
  MALE = 1,
  FEMALE,
  DIVERS
}
